import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { VesselStatusDisplayName } from 'server/enums/VesselStatus';
import { PendingVesselServiceListing, PendingVesselModel } from './model';
import { TypeaheadInput } from 'portcall/typeahead/view';

function PageTitle(m : PendingVesselServiceListing) {
    return (m.Model.Status() === null ? '' : VesselStatusDisplayName[m.Model.Status()!] + ' ') + 'Vessels';
}


export const PendingVesselServiceListingView = SuperCritical(({ model: m} : { model : PendingVesselServiceListing }) =>
    <div className="vesselservicelisting pc-page-fixedwidth">
        {/*<loadingindicator params="request: Request" />*/}
        <div className="pc-actions-links-header">
            <a className="pc-back-link" href="#!siteadminsettings">&lt;&lt; Back to Site Admin Settings</a>
        </div>
        <h1 className="pc-page-title">
            <span className="pc-text-label-color">More</span><span className="pc-icon-bullet pc-text-label-color"></span>
            <span className="pc-text-label-color">Site Admin Settings</span><span className="pc-icon-bullet"></span>
            <span>{PageTitle(m)}</span>
        </h1>
        <PageBody model={m} />
    </div>
);

let PageBody = SuperCritical(({ model: m } : { model : PendingVesselServiceListing }) =>
    <div className="page-body pc-card">
        <h2 className="pc-card-title page-body-title">{PageTitle(m)}</h2>
        <table className="table">
            <thead>
                <tr>
                    <th>Vessel Name</th>
                    <th>IMO</th>
                    <th>MMSI</th>
                    <th>Call Sign</th>
                    <th>Gross Tonnage</th>
                    <th>Length</th>
                    <th>Beam</th>
                </tr>
            </thead>
            <TableBody model={m} />
        </table>
    </div>
);

let TableBody = SuperCritical(({ model: m } : { model : PendingVesselServiceListing }) =>
    <tbody>
        {m.Vessels().map(vessel =>
            <VesselRow vessel={vessel} key={vessel.Model.Id()} />
        )}
    </tbody>
);

let VesselRow = SuperCritical(({ vessel: v } : { vessel : PendingVesselModel }) =>
    <tr className="vessel-row" onClick={v.OnRowClick}>
        <td>{v.Model.Name()}</td>
        <td>{v.Model.IMO()}</td>
        <td>{v.Model.MMSID()}</td>
        <td>{v.Model.CallSign()}</td>
        <td>{v.Model.GrossTonnage.toString()}</td>
        <td>{v.Model.Length.toString()}</td>
        <td>{v.Model.Beam.toString()}</td>
    </tr>
);


// WEBPACK FOOTER //
// ./apps/portcall/pendingvesselservicelisting/view.tsx